import React, { useMemo } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';

const PurchaseOrderDetailModal = ({ modalOpen, setModalOpen, data }) => {
    const cols = [
        {
            Header: 'batch no',
            accessor: 'batchNo',
        },
        {
            Header: 'quality Name',
            accessor: 'qualityName',
        },
        {
            Header: 'HSN Code',
            accessor: 'hsnCode',
        },
        {
            Header: 'meter',
            accessor: 'meter',
        },
        {
            Header: 'rate',
            accessor: 'rate',
        },
        {
            Header: 'taka',
            accessor: 'taka',
        },
    ];

    const colsMemo = useMemo(() => cols ?? [], [cols]);

    const poDetailMemo = useMemo(
        () =>
            data?.poDetails && data?.poDetails.length > 0
                ? data?.poDetails
                : [],
        [data?.poDetails]
    );

    const groupedData = data?.millReceive.reduce((acc, d) => {
        if (!acc[d.invoiceNo]) {
            acc[d.invoiceNo] = [];
        }
        acc[d.invoiceNo].push(d.poData.challanNo);
        return acc;
    }, {});

    const cuttingCardData = data?.cuttingCard.reduce((acc, d) => {
        if (!acc[d.cuttingCardNumber]) {
            acc[d.cuttingCardNumber] = [];
        }
        acc[d.cuttingCardNumber].push(d.millChallanNo);
        return acc;
    }, {});

    const jobWorkData = data?.jobWork.reduce((acc, d) => {
        if (!acc[d.jobWorkNumber]) {
            acc[d.jobWorkNumber] = [];
        }
        acc[d.jobWorkNumber].push(d.cuttingCard?.cuttingCardNumber);
        return acc;
    }, {});
    console.log(groupedData, 'groupedData');

    return (
        <ModalBasic modalOpen={modalOpen} setModalOpen={setModalOpen}>
            <div className="p-4">
                <TableWithHeadingAndSearch
                    columns={colsMemo}
                    data={poDetailMemo}
                    heading={'Purchase Order Details'}
                />
                <div className="p-2">
                    <h2 className="mt-2 font-semibold">Mill Dispatch</h2>
                    <div>
                        {data?.millPurchaseOrder
                            .map((d) => d.challanNo)
                            .join(', ')}
                    </div>
                    <div className="mt-2">
                        <h2 className="font-semibold">Mill Receive</h2>
                        <div>
                            {groupedData &&
                                Object.entries(groupedData).map(
                                    ([invoiceNumber, challans]) => (
                                        <div key={invoiceNumber}>
                                            <span>
                                                Invoice No. {invoiceNumber} -{' '}
                                                {challans
                                                    .map((d) => d)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                    )
                                )}
                        </div>
                    </div>
                    {data?.cuttingCard?.length > 0 && (
                        <div className="mt-2">
                            <h2 className="font-semibold">Cutting Card</h2>
                            {cuttingCardData &&
                                Object.entries(cuttingCardData).map(
                                    ([invoiceNumber, challans]) => (
                                        <div key={invoiceNumber}>
                                            <span>
                                                CC No. {invoiceNumber} -{' '}
                                                {challans
                                                    .map((d) => d)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                    )
                                )}
                        </div>
                    )}
                    {data?.jobWork?.length > 0 && (
                        <div className="mt-2">
                            <h2 className="font-semibold">Job Work</h2>
                            {jobWorkData &&
                                Object.entries(jobWorkData).map(
                                    ([invoiceNumber, challans]) => (
                                        <div key={invoiceNumber}>
                                            <span>
                                                Invoice No. {invoiceNumber} -{' '}
                                                {challans
                                                    .map((d) => d)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                    )
                                )}
                        </div>
                    )}
                </div>
            </div>
        </ModalBasic>
    );
};

export default PurchaseOrderDetailModal;
